import { t } from "../contract/strings";

/**
 * The server's label for speech no device's owner claimed. Stored results and the code that
 * matches on it keep this exact string; only what a reader sees changes.
 */
export const UNATTRIBUTED_SPEAKER = "Unattributed";

/** How that speech reads on screen and in an export (`result.someone_else`). */
export const UNATTRIBUTED_DISPLAY = t("result.someone_else");

/**
 * A speaker label as a person reads it. The one place a stored label is turned into
 * display text: "Unattributed" reads "Someone else"; every other name, including the
 * anonymous "Speaker A", is shown as it is.
 */
export function speakerName(label: string | null | undefined): string {
  if (!label) return "";
  return label === UNATTRIBUTED_SPEAKER ? UNATTRIBUTED_DISPLAY : label;
}
